//#region Imports

import { Route } from '@angular/router';
import { environment } from '../../environments/environment';
import { AuthenticateGuard } from '../guards/authenticate/authenticate.guard';
import { SetupAuthenticationGuard } from '../guards/authenticate/setup-authentication.guard';

//#endregion

/**
 * As configuracoes para as rotas que NAO precisam de autenticacao
 */
export const unAuthenticatedRoute: Partial<Route> = {
  canActivate: [SetupAuthenticationGuard, AuthenticateGuard],
  data: { routeToRedirect: environment.config.redirectToWhenAuthenticated, unprotectedRoute: true }
};

/**
 * As configuracoes para as rotas que PRECISAM de autenticacao
 */
export const authenticatedRoute: Partial<Route> = {
  canActivate: [SetupAuthenticationGuard, AuthenticateGuard],
  data: { routeToRedirect: environment.config.redirectToWhenUnauthenticated, protectedRoute: true }
};
